module.exports = __webpack_public_path__ + "media/images/noticias/viejas/maqueta-17c6a8bdf5d1a238143a2cf677f51877.jpg";